<template>
    <input
        type="color"
        v-bind="$attrs"
        :class="{
            'bg-white': !disabled,
            'bg-stone-100 text-gray-500 focus:border-stone-200 select-none cursor-not-allowed':
                disabled,
        }"
        class="p-1 h-10.5 w-full block bg-white border border-stone-200 shadow-xs cursor-pointer rounded-lg2"
        @input="handleInputEvent($event)"
        :value="modelValue"
    />
</template>

<script setup lang="ts">
    const emits = defineEmits<{
        'update:modelValue': [value: string]
    }>()

    defineProps({
        modelValue: {
            type: String,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    })

    const handleInputEvent = (event: Event) => {
        const target = event.target as HTMLInputElement | null

        if (!target?.value) {
            throw new Error('target.value should be a string.')
        }

        emits('update:modelValue', target.value)
    }
</script>
